// components/artifacts/ArtifactModals.js - 아티팩트 모달 컴포넌트

import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { DeleteConfirmModal } from '../ui';
import DistributeModal from '../DistributeModal';
import { getArtifactTypeName } from '../../utils/artifactUtils';

/**
 * 아티팩트 모달 컴포넌트
 * @param {object} props
 * @param {object} props.artifact - 아티팩트 객체
 * @param {string} props.studySlug - 연구 slug
 * @param {number} props.studyId - 연구 ID
 * @param {string} props.artifactId - 아티팩트 ID
 * @param {object} props.deleteConfirmModal - 삭제 확인 모달 상태
 * @param {object} props.googleFormsModal - 구글 폼 모달 상태
 * @param {object} props.distributeModal - 배포 모달 상태
 * @param {function} props.onDeleteConfirm - 삭제 확인 핸들러
 * @param {function} props.onDeleteCancel - 삭제 취소 핸들러
 * @param {function} props.onDeleteSuccessClose - 삭제 성공 모달 닫기 핸들러
 * @param {function} props.onDeleteSuccessNavigate - 삭제 성공 후 네비게이션 핸들러
 * @param {function} props.onGoogleFormsModalClose - 구글 폼 모달 닫기 핸들러
 * @param {function} props.onGoogleFormsScriptCopy - 구글 폼 스크립트 복사 핸들러
 * @param {function} props.onDistributeModalClose - 배포 모달 닫기 핸들러
 */
const ArtifactModals = ({
  artifact,
  studySlug,
  studyId,
  artifactId,
  deleteConfirmModal,
  googleFormsModal,
  distributeModal,
  onDeleteConfirm,
  onDeleteCancel,
  onGoogleFormsModalClose,
  onGoogleFormsScriptCopy,
  onDistributeModalClose,
}) => {
  return (
    <>
      {/* 산출물 삭제 확인 모달 */}
      <DeleteConfirmModal
        isOpen={deleteConfirmModal.isOpen}
        title="산출물 삭제"
        className="delete-confirm-modal--artifact"
        itemName={getArtifactTypeName(artifact?.artifact_type)}
        onConfirm={onDeleteConfirm}
        onCancel={onDeleteCancel}
      />

      {/* 구글 폼 생성 안내 모달 */}
      {googleFormsModal.isOpen && (
        <div
          className="google-form-modal-overlay"
        >
          <div
            className="google-form-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="google-form-modal-close"
              onClick={onGoogleFormsModalClose}
              aria-label="구글 폼 생성 가이드 닫기"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="google-form-modal-title">구글 폼 생성 가이드</h2>

            <div className="google-form-modal-section">
              <h3 className="google-form-modal-subtitle">📋 생성 방법</h3>
              <ol className="google-form-modal-list">
                <li>
                  <strong>script.google.com</strong> 접속
                </li>
                <li>
                  좌측 상단 <strong>'새 프로젝트 생성'</strong> 버튼 클릭
                  <ul className="google-form-modal-sublist">
                    <li>기존 코드 삭제 후, 복사된 코드 붙여넣기</li>
                    <li>Drive에 프로젝트 저장 버튼 클릭</li>
                    <li>실행 버튼 클릭</li>
                  </ul>
                </li>
                <li>
                  <strong>엑세스 요청 승인</strong>
                </li>
                <li>
                  <strong>구글 드라이브</strong> 혹은 <strong>구글 폼</strong>에서 생성된 폼 확인
                </li>
              </ol>
            </div>

            <div className="google-form-modal-actions">
              <button
                type="button"
                className="google-form-modal-button primary"
                onClick={onGoogleFormsScriptCopy}
              >
                스크립트 복사
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 배포 모달 */}
      <DistributeModal
        isOpen={distributeModal.isOpen}
        onClose={onDistributeModalClose}
        surveyData={distributeModal.surveyData}
        studyId={studyId}
        artifactId={artifactId}
      />
    </>
  );
};

export default ArtifactModals;
